import { BrowseComponentsInteractiveRow } from './BrowseComponentsInteractiveRow';
import { CreateComponentsInteractiveRow } from './CreateComponentsInteractiveRow';
import {
  InventoryInteractiveTopRowCommands,
  InventoryInteractiveTopRowViewState,
} from './types';
import { SelectionInteractiveTopRow } from './SelectionInteractiveTopRow';
import { EditingReportDataInteractiveRow } from './EditingReportDataInteractiveRow';
import { FilterDataInteractiveRow } from './FilterDataInteractiveRow';
import { type I18nLocale } from '@ardoq/i18n';

export type InventoryInteractiveRowProps = {
  commands: InventoryInteractiveTopRowCommands;
  state: InventoryInteractiveTopRowViewState;
  i18nLocale: I18nLocale;
};

export const InventoryInteractiveTopRow = ({
  commands,
  state,
  i18nLocale,
}: InventoryInteractiveRowProps) => {
  switch (state.mode) {
    case 'browseComponents':
      return (
        <BrowseComponentsInteractiveRow
          commands={commands}
          state={state}
          i18nLocale={i18nLocale}
        />
      );
    case 'createComponents':
      return (
        <CreateComponentsInteractiveRow
          commands={commands}
          i18nLocale={i18nLocale}
        />
      );
    case 'componentsSelected':
      return (
        <SelectionInteractiveTopRow
          commands={commands}
          state={state}
          i18nLocale={i18nLocale}
        />
      );
    case 'editingReportData':
      return (
        <EditingReportDataInteractiveRow
          state={state}
          i18nLocale={i18nLocale}
        />
      );
    case 'filterData':
      return (
        <FilterDataInteractiveRow
          state={state}
          commands={commands}
          i18nLocale={i18nLocale}
        />
      );
    default:
      state satisfies never;
      return null;
  }
};
